import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "text-base text-center"
};
const _hoisted_2 = {
  key: 0,
  class: "text-base flex-center"
};
const _hoisted_3 = {
  key: 1,
  class: "text-base flex-center"
};
import GridItem from "@/modules/club-grounds/components/GridItem.vue";
import { app } from "@/di";
import SlotDemolisher from "@/modules/club-grounds/services/SlotDemolisher";
import { GroundSlotTypeEnum } from "@/modules/club-grounds/enums";
import { ColorEnum } from "@/modules/vue/enums";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
export default /*#__PURE__*/_defineComponent({
  __name: 'DevelopedSlot',
  props: {
    groundSlot: null,
    team: null
  },
  emits: ['update'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const color = computed(() => {
      return {
        [GroundSlotTypeEnum.HEADQUATERS]: ColorEnum.Sky,
        [GroundSlotTypeEnum.PUBLIC_RELATIONS]: ColorEnum.Purple,
        [GroundSlotTypeEnum.SCOUTING]: ColorEnum.Slate,
        [GroundSlotTypeEnum.YOUTH]: ColorEnum.Lime,
        [GroundSlotTypeEnum.OFFICE]: ColorEnum.Indigo,
        [GroundSlotTypeEnum.TRAINING]: ColorEnum.Emerald
      }[props.groundSlot.type];
    });
    const demolishConfirmDialog = ref(null);
    const cancelDemolishConfirmDialog = ref(null);
    const demolishPrice = computed(() => app.get(ConfigRepository).get('clubGrounds.costs.demolish')(props.groundSlot));
    const onDemolish = async () => {
      await demolishConfirmDialog.value.confirm();
      await app.get(SlotDemolisher).queue(props.groundSlot);
      emit('update');
    };
    const onCancelDemolish = async () => {
      await cancelDemolishConfirmDialog.value.confirm();
      await app.get(SlotDemolisher).cancel(props.groundSlot);
      emit('update');
    };
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(GridItem, {
        color: _unref(color)
      }, {
        default: _withCtx(() => [_createVNode(_component_Icon, {
          icon: _ctx.IconEnum.CheckmarkDone,
          size: "3rem",
          class: "mb-1"
        }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_1, _toDisplayString(__props.groundSlot.type), 1), __props.groundSlot.developedAt ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Icon, {
          icon: _ctx.IconEnum.Crane,
          class: "mr-1"
        }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_ctx.$date(__props.groundSlot.developedAt)), 1)])) : _createCommentVNode("", true), __props.groundSlot.demolishAt ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_Icon, {
          icon: _ctx.IconEnum.Bulldozer,
          class: "mr-1"
        }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_ctx.$date(__props.groundSlot.demolishAt)), 1)])) : _createCommentVNode("", true), __props.groundSlot.demolishable && !__props.groundSlot.developedAt ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [!__props.groundSlot.demolishAt ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_NButton, {
          secondary: "",
          type: "error",
          size: "small",
          class: "mt-2",
          onClick: onDemolish
        }, {
          default: _withCtx(() => [_createVNode(_component_Icon, {
            icon: _ctx.IconEnum.Bulldozer
          }, null, 8, ["icon"])]),
          _: 1
        }), _createVNode(RichDialog, {
          ref_key: "demolishConfirmDialog",
          ref: demolishConfirmDialog,
          price: _unref(demolishPrice),
          "gate-type": _ctx.GateTypeEnum.BALANCE,
          "gate-value": _unref(demolishPrice)
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('are_you_sure?')), 1)]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(_ctx.$t('you_will_lose_the_type_developed_on_this_ground')), 1)]),
          _: 1
        }, 8, ["price", "gate-type", "gate-value"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_NButton, {
          secondary: "",
          type: "error",
          size: "small",
          class: "mt-2",
          onClick: onCancelDemolish
        }, {
          default: _withCtx(() => [_createVNode(_component_Icon, {
            icon: _ctx.IconEnum.Ban
          }, null, 8, ["icon"])]),
          _: 1
        }), _createVNode(RichDialog, {
          ref_key: "cancelDemolishConfirmDialog",
          ref: cancelDemolishConfirmDialog
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('are_you_sure?')), 1)]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(_ctx.$t('no_money_will_be_refunded')), 1)]),
          _: 1
        }, 512)], 64))], 64)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["color"]);
    };
  }
});